module.exports = __webpack_public_path__ + "img/customer_gumi.d61e522f.jpeg";